import { Component, Input, OnInit } from '@angular/core';
import { ProductListForCreatePortfolio } from '../../../../../../model/finzy-flex/product-list.model';

@Component({
  selector: 'app-products-invest-amount',
  templateUrl: './products-invest-amount.component.html',
  styleUrls: ['./products-invest-amount.component.css']
})
export class ProductsInvestAmountComponent implements OnInit {

  @Input() productList: ProductListForCreatePortfolio;
  constructor() { }

  ngOnInit(): void {
  }

}
